<template>
  <div>
    <v-autocomplete
      v-model="selectedItem"
      :items="lista"
      :item-text="itemText"
      :item-value="itemValue"
      :placeholder="
        $t(
          `placeholders.${
            lista && lista.length > 0 ? 'autocomplete' : 'busca'
          }`,
          { campo: rotulo }
        )
      "
      :label="rotulo"
      :hint="rotulo"
      :rules="rules"
      :size="size"
      clearable
      hide-no-data
      @change="updateValue"
      @keydown="updateSearch"
      class="text-caption"
      persistent-placeholder
      persistent-hint
      return-object
      single-line
      outlined
      :dark="dark"
      dense
      multiple
      :chips="isChips"
      v-bind="$attrs"
      ><template v-if="isChips" v-slot:selection="{ item, index }">
        <v-chip v-if="index === 0">
          <span>{{ item.DESCRICAO ? item.DESCRICAO : item.title }}</span>
        </v-chip>
        <span v-if="index === 1" class="grey--text caption">
          (+{{ `${selectedItem.length - 1} ${$t('labels.outros')}` }} )
        </span>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    itemValue: {
      type: String,
      default: 'CODIGO',
    },
    itemText: {
      type: String,
      default: 'DESCRICAO',
    },
    rotulo: {
      type: String,
      default: '',
    },
    lista: {
      type: Array,
      default: () => [],
    },
    item: {
      type: [Object, String, Array],
      default: () => {},
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 0,
    },
    isChips: {
      type: Boolean,
      default: true,
    },
    dark: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    selectedItem: {
      get() {
        return this.item
      },
      set(val) {
        this.$emit('update:item', val)
      },
    },
    rules() {
      const rules = []
      if (this.isRequired) {
        const rule = (value) =>
          !!value || this.$t('validation-messages.requiredField')
        rules.push(rule)
      }
      return rules
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value)
    },
    updateSearch(value) {
      this.$emit('searchinput', value)
    },
  },
}
</script>

<style></style>
